export default "__VITE_ASSET__Ck4g4Aym__"